<template>
  <div
    v-if="contextData.userData.displayName"
    class="dropdown"
  >
    <a
      href="#"
      class="dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="fa-solid fa-user" />
      <span class="ms-2">{{ contextData.userData.displayName }}</span> <b class="caret" />
    </a>
    <ul
      id="dropdown-usernav-menu"
      role="menu"
      class="dropdown-menu"
    >
      <li
        role="menuitem"
      >
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="logout"
        >{{ $localize('Logout') }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
  import redirectHelper from '@/Utils/redirectHelper';

  const contextData = useContextDataStore();

  const logout = () => {
    redirectHelper.logoutRedirect();
  };
</script>

